import { call, put, takeEvery } from 'redux-saga/effects'

import appActions from '../App/actions'
import { actions } from './slice'

const fetchSaga = function* () {
  try {
    performance.mark('ConfigFetch:start')
    const res = yield call(window.fetch, '/exchange-config.json')
    performance.mark('ConfigFetch:end')
    performance.measure('ConfigFetch', 'ConfigFetch:start', 'ConfigFetch:end')
    const config = yield call([res, res.json])
    window.env = config.env
    yield put(actions.setConfig(config))
    yield put(appActions.bootstrap())
  } catch (e) {
    yield put(actions.error())
  }
}

const configSagas = function* () {
  yield takeEvery(actions.fetch.type, fetchSaga)
}

export default configSagas
